import { Logo } from "common/components/Logo";
import { NavigatorGoToOrgItem } from "common/components/Navigator/types";
import { useAppSelector } from "common/hooks/storeHooks";
import { getUrl } from "common/records/Image";
import { orgOverviewLogo } from "common/selectors/org.selectors";

export interface OrgItemLabelProps {
  item: NavigatorGoToOrgItem;
}

export const OrgItemLabel: React.FC<OrgItemLabelProps> = ({ item }) => {
  const logo = useAppSelector((state) => orgOverviewLogo(state, { orgId: item.orgId }));

  return (
    <>
      <span className="mr-3 px-2 py-1 text-sm font-semibold text-orange-700 bg-orange-100 rounded">Go to Org</span>
      {logo && (
        <div className="h-[40px] mr-sm">
          <Logo src={getUrl(logo, "small")} alt={`Org ${item.orgId} Logo`} />
        </div>
      )}
    </>
  );
};
